import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import PublicLayout from './components/layouts/PublicLayout';
import ProtectedRoute from './components/auth/ProtectedRoute';
import Home from './pages/public/Home';
import About from './pages/public/About';
import Services from './pages/public/Services';
import Products from './pages/public/Products';
import Careers from './pages/public/Careers';
import Contact from './pages/public/Contact';
import Privacy from './pages/public/Privacy';
import Terms from './pages/public/Terms';
import Refund from './pages/public/Refund';
import ListingPriceCalculator from './pages/public/ListingPriceCalculator';
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import Dashboard from './pages/dashboard/Dashboard';
import Profile from './pages/dashboard/Profile';
import DecisionHub from './pages/dashboard/DecisionHub';
import ProductListing from './pages/dashboard/ProductListing';
import TeamDiscussion from './pages/dashboard/TeamDiscussion';
import Announcements from './pages/dashboard/Announcements';

function App() {
  return (
    <AuthProvider>
      <NotificationProvider>
        <Router>
          <div className="App">
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<PublicLayout />}>
                <Route index element={<Home />} />
                <Route path="about" element={<About />} />
                <Route path="services" element={<Services />} />
                <Route path="products" element={<Products />} />
                <Route path="careers" element={<Careers />} />
                <Route path="contact" element={<Contact />} />
                <Route path="privacy" element={<Privacy />} />
                <Route path="terms" element={<Terms />} />
                <Route path="refund" element={<Refund />} />
                <Route path="listing-calculator" element={<ListingPriceCalculator />} />
              </Route>

              {/* Auth Routes */}
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />

              {/* Protected Team Portal Routes */}
              <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
              <Route path="/decisions" element={<ProtectedRoute><DecisionHub /></ProtectedRoute>} />
              <Route path="/team-products" element={<ProtectedRoute><ProductListing /></ProtectedRoute>} />
              <Route path="/discussion" element={<ProtectedRoute><TeamDiscussion /></ProtectedRoute>} />
              <Route path="/announcements" element={<ProtectedRoute><Announcements /></ProtectedRoute>} />
            </Routes>
          </div>
        </Router>
      </NotificationProvider>
    </AuthProvider>
  );
}

export default App;
